import { render, staticRenderFns } from "./BarraProgreso.vue?vue&type=template&id=495bedb5&scoped=true"
import script from "./BarraProgreso.vue?vue&type=script&lang=js"
export * from "./BarraProgreso.vue?vue&type=script&lang=js"
import style0 from "./BarraProgreso.vue?vue&type=style&index=0&id=495bedb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bedb5",
  null
  
)

export default component.exports